export default "__VITE_ASSET__DLrUNC82__"